import { BrokerOffers, BrokerOffersVariables } from "_graphql/queries/__generated__/BrokerOffers";
import { getPlaceItOfferMessages, getPlaceItOffers } from "_graphql/place-it/queries/offers.place-it";

import { Offer_messages } from "_graphql/queries/__generated__/Offer_messages";
import { Offer_messagesVariables } from "_graphql/queries/__generated__/Offer_messages";
import { placeItClient } from "_graphql";
import { useQuery } from "@apollo/client";

export const usePlaceItOffers = (variables: BrokerOffersVariables) => {
    const { data, ...rest } = useQuery<BrokerOffers, BrokerOffersVariables>(getPlaceItOffers, {
        variables,
        client: placeItClient,
        fetchPolicy: "network-only",
    });

    return { offers: data?.brokerOffers?.data || [], length: data?.brokerOffers?.paginatorInfo?.total || 0, ...rest };
}

export const usePlaceItOfferMessages = (variables: Offer_messagesVariables) => {
    const { data, ...rest } = useQuery<Offer_messages, Offer_messagesVariables>(getPlaceItOfferMessages, {
        variables,
        client: placeItClient,
        fetchPolicy: "network-only",
        pollInterval: 1000 * 15
    });


    return { offers: data?.offer_messages || [], ...rest };
}